import { Component } from '@angular/core';

@Component({
  selector: 'icon-play',
  standalone: true,
  template: `
    <!-- <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-play-icon lucide-play">
        <path d="M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z"/>
    </svg> -->
    <svg width="88" height="48" viewBox="0 0 88 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 24C0 10.7452 10.7452 0 24 0H64C77.2548 0 88 10.7452 88 24C88 37.2548 77.2548 48 64 48H24C10.7452 48 0 37.2548 0 24Z" fill="#1C6E70"/>
      <mask id="mask0_26_1015" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="32" y="12" width="24" height="24">
          <rect x="32" y="12" width="24" height="24" fill="#D9D9D9"/>
      </mask>
      <g mask="url(#mask0_26_1015)">
          <path d="M40 31V17L51 24L40 31Z" fill="white"/>
      </g>
  </svg>
  `,
  styles: [`
    svg {
        path {
          fill: var(--main-color);
        }
        g {
          path{
            fill: white;
          }
        }
    }

    svg:hover {
        path {
          fill: var(--main-color-strong);
        }
        g {
          path{
            fill: #0B2C2D;
          }
        }
    }

      svg:active {
        path {
          fill: #000;
        }
        g {
          path{
            fill: white;
          }
        }
    }

  `]
})

export class PlayIconComponent {

}
